import { isPublicApiPath, isSoftSessionBootstrapPath } from '@/api/client';

export function shouldSuppressGlobalError(
  url?: string,
  status?: number,
): boolean {
  if (!url || !status) {
    return false;
  }

  const normalizedPath = (() => {
    try {
      const parsed = url.startsWith('http') ? new URL(url).pathname : url;
      return parsed.replace(/^\/api\/v1/, '');
    } catch {
      return url.replace(/^\/api\/v1/, '');
    }
  })();

  if (status === 404 && /^\/orders\/[^/]+$/.test(normalizedPath)) {
    return true;
  }

  if (status === 404 && /^\/clients\/[^/]+\/communications$/.test(normalizedPath)) {
    return true;
  }

  // FLOW[49932]: профиль требований к макету ещё не привязан.
  // Resolve использует 404 как штатное состояние «не настроено»; сам блок
  // карточки уже отличает этот ответ от 5xx и показывает понятную пустую секцию.
  // Подавляем только query-toast точного resolve endpoint — остальные 404 видны.
  if (
    status === 404 &&
    /^\/artwork-requirements\/resolve(?:\?|$)/.test(normalizedPath)
  ) {
    return true;
  }

  // FLOW[49219]: KV-настройка, которую ещё ни разу не сохраняли.
  //
  // `GET /settings/system/{key}` отвечает 404, пока ключа нет в базе — это
  // нормальное начальное состояние, а не отказ: секция настроек в этом случае
  // штатно показывает значение по умолчанию, совпадающее с дефолтом бэкенда.
  // Без этого правила КАЖДОЕ первое открытие такой секции встречало админа
  // красным «Не найдено: System setting not found» — сообщением, на которое
  // нечего ответить и которое врёт о состоянии системы.
  //
  // Подавляется ровно 404 и ровно на чтении по ключу: 403 (нет права) и 5xx
  // по-прежнему видны, а сохранение настройки идёт мутацией со своим тостом.
  if (status === 404 && /^\/settings\/system\/[A-Za-z0-9_.-]+$/.test(normalizedPath)) {
    return true;
  }

  if (!isPublicApiPath(url)) {
    if (isSoftSessionBootstrapPath(url)) {
      return status === 401 || status === 403 || status === 404;
    }
    return false;
  }

  return status === 401 || status === 403;
}
